import { translate } from "../../util/translate"

export const headers = [
  {
    text: translate['partner.label.name'],
    value: 'name',
    width: '200',
  },
  {
    text: translate['partner.label.description'],
    value: 'description',
    width: '300',
  },
  {
    text: translate['partner.label.dateCreated'],
    value: 'date_created',
    width: '150',
  },
  {
    text: translate['partner.label.asaas'],
    value: 'id',
    align: 'center',
    width: '50',
  },
  { value: 'actions', align: 'end', width: 100 },
]
